"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSpring = void 0;
var components_1 = require("./components");
var utility_1 = require("./utility");
/**
 * @typeparam ResultSchema  Schema defined within SearchSpring, extends [[SearchSpring.Query.Results.Defaults]].
 */
var SearchSpring = /** @class */ (function () {
    function SearchSpring(options) {
        var _this = this;
        var _a, _b;
        this.options = options;
        /** Set to `true` after the first **SearchSpring request**. */
        this.ready = false;
        /** Set to `true` while a **SearchSpring request** is being processed. */
        this.loading = false;
        /** Same as `loading` but directional */
        this.loadingNext = false;
        /** Same as `loading` but directional */
        this.loadingPrev = false;
        this.infinite = {
            pageStart: 0,
            pageEnd: 0,
            results: {},
            regions: [0],
        };
        this.changed = {};
        /** @hidden */
        this.memoize = {};
        /** @hidden */
        this.debounce = {
            autocomplete: null,
            search: null,
            suggest: null,
        };
        /** @hidden */
        this.throttle = {
            scroll: null,
        };
        this.apiEndpoints = {
            search: "https://api.searchspring.net/api/search/search.json",
            suggest: "https://suggest.searchspring.net/api/suggest/query",
        };
        this.searchSpringInstanceId = Math.random().toString(16).substr(2);
        if (this.options.userId) {
            this.intellisuggest = new utility_1.Intellisuggest(this.options.siteId, this.options.userId);
        }
        if ((_a = this.options.apiEndpoints) === null || _a === void 0 ? void 0 : _a.search) {
            this.apiEndpoints.search = this.options.apiEndpoints.search;
        }
        if ((_b = this.options.apiEndpoints) === null || _b === void 0 ? void 0 : _b.suggest) {
            this.apiEndpoints.suggest = this.options.apiEndpoints.suggest;
        }
        this.setQuery({
            filters: {},
            ranges: {},
            bgFilters: {},
            sort: {
                field: null,
                direction: null,
            },
            results: {
                format: SearchSpring.Query.Results.Format.NATIVE,
                page: null,
                limit: null,
            },
            suggest: "",
            search: "",
        });
        this.current = {
            results: [],
            facets: [],
            suggestions: [],
            autocomplete: "",
            sorting: null,
            pagination: null,
            merchandising: null,
        };
        if (this.options.debounce) {
            if (this.options.debounce.autocomplete) {
                this.debounce.autocomplete = new utility_1.Debounce("autocomplete", this.options.debounce.autocomplete);
            }
            if (this.options.debounce.search) {
                this.debounce.search = new utility_1.Debounce("search", this.options.debounce.search);
            }
            if (this.options.debounce.suggest) {
                this.debounce.suggest = new utility_1.Debounce("suggest", this.options.debounce.suggest);
            }
        }
        if (this.options.throttle) {
            if (this.options.throttle.scroll) {
                this.throttle.scroll = new utility_1.Throttle("scroll", this.options.throttle.scroll);
            }
        }
        if (this.options.querystring) {
            this.parseUrlSearchParams();
            window.addEventListener("popstate", function (event) {
                _this.parseUrlSearchParams();
                _this.execSearch();
            });
            this.infinite.pageStart = this.query.results.page || this.infinite.pageStart;
            this.infinite.pageEnd = this.query.results.page || this.infinite.pageEnd;
        }
        if (this.options.query) {
            this.setQuery(this.options.query);
        }
    }
    /** Encode a partial [[SearchSpring.Query.Query]] to base64. */
    SearchSpring.encodeQuery = function (query, changed) {
        if (changed === void 0) { changed = {}; }
        var urlSearchParams = new URLSearchParams();
        for (var _i = 0, _a = Object.keys(query.filters || {}); _i < _a.length; _i++) {
            var filter = _a[_i];
            if (query.filters[filter] && changed["facet:" + filter]) {
                if (Array.isArray(query.filters[filter])) {
                    urlSearchParams.set("filter." + filter, query.filters[filter].map(function (value) { return encodeURIComponent(value.value); }).toString());
                }
                else {
                    urlSearchParams.set("filter." + filter, encodeURIComponent(query.filters[filter].value.toString()));
                }
            }
        }
        for (var _b = 0, _c = Object.keys(query.ranges || {}); _b < _c.length; _b++) {
            var range = _c[_b];
            if (query.ranges[range] && changed["facet:" + range]) {
                urlSearchParams.set("range." + range, encodeURIComponent([query.ranges[range].low, query.ranges[range].high].toString()));
            }
        }
        for (var _d = 0, _e = Object.keys(query.bgFilters || {}); _d < _e.length; _d++) {
            var bgFilter = _e[_d];
            if (query.bgFilters[bgFilter] && changed["bgfilter:" + bgFilter]) {
                urlSearchParams.set("bgfilter." + bgFilter, encodeURIComponent(query.bgFilters[bgFilter].toString()));
            }
        }
        if (query.sort && query.sort.field && changed.sortField) {
            urlSearchParams.set("sort.field", encodeURIComponent(query.sort.field));
        }
        if (query.sort && query.sort.direction && changed.sortDirection) {
            urlSearchParams.set("sort.direction", query.sort.direction);
        }
        if (query.results && query.results.page && changed.resultsPage) {
            urlSearchParams.set("results.page", query.results.page.toString());
        }
        if (query.results && query.results.limit && changed.resultsLimit) {
            urlSearchParams.set("results.limit", query.results.limit.toString());
        }
        if (query.search && changed.search) {
            urlSearchParams.set("q", encodeURIComponent(query.search));
        }
        return urlSearchParams.toString();
    };
    /** Decode a partial [[SearchSpring.Query.Query]] from a base64 encoded string. */
    SearchSpring.decodeQuery = function (query) {
        var urlSearchParams = new URLSearchParams(query);
        var queryObject = {
            filters: {},
            ranges: {},
            bgFilters: {},
            tag: urlSearchParams.get("tag"),
            sort: {
                field: urlSearchParams.get("sort.field"),
                direction: urlSearchParams.get("sort.direction"),
            },
            search: urlSearchParams.get("q"),
            results: {
                page: parseInt(urlSearchParams.get("results.page"), 10) || undefined,
                limit: parseInt(urlSearchParams.get("results.limit"), 10) || undefined,
                format: urlSearchParams.get("results.format") || SearchSpring.Query.Results.Format.NATIVE,
            },
        };
        urlSearchParams.forEach(function (value, key) {
            if (key.match(/^filter\./)) {
                var values = value.split(",");
                var field = key.replace(/^filter\./, "");
                queryObject.filters[field] = values.map(function (value) {
                    return {
                        type: SearchSpring.Query.Facet.Value.Type.VALUE,
                        value: value,
                        active: true,
                        label: value,
                        count: null,
                    };
                });
                if (values.length === 1) {
                    queryObject.filters[field] = queryObject.filters[field][0];
                }
            }
            if (key.match(/^range\./)) {
                var range = value.split(",");
                var field = key.replace(/^range\./, "");
                queryObject.ranges[field] = {
                    type: SearchSpring.Query.Facet.Value.Type.RANGE,
                    low: range[0],
                    high: range[1],
                    active: true,
                    label: value,
                    count: null,
                };
            }
            if (key.match(/^bgfilter\./)) {
                var field = key.replace(/^bgfilter\./, "");
                queryObject.bgFilters[field] = value;
            }
        });
        return queryObject;
    };
    /** Correctly formats a URL with [URLSearchParams](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams) for a given filter. */
    SearchSpring.filterToUrl = function (facet, value, href) {
        var _a, _b;
        return SearchSpring.queryToUrl({ filters: (_a = {}, _a[facet.field] = value, _a) }, (_b = {}, _b["facet:" + facet.field] = true, _b), href);
    };
    /** Correctly formats a URL with [URLSearchParams](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams) for a given range. */
    SearchSpring.rangeToUrl = function (facet, value, href) {
        var _a, _b;
        return SearchSpring.queryToUrl({ ranges: (_a = {}, _a[facet.field] = value, _a) }, (_b = {}, _b["facet:" + facet.field] = true, _b), href);
    };
    /** @hidden */
    SearchSpring.queryToUrl = function (query, changed, href) {
        var urlHref = href.split("?")[0];
        var urlSearchParamString = decodeURIComponent(SearchSpring.encodeQuery(query, changed));
        if (!urlSearchParamString) {
            return urlHref;
        }
        return urlHref + "?" + urlSearchParamString;
    };
    /** @hidden */
    SearchSpring.prototype.parseUrlSearchParams = function () {
        var urlSearchParamsString = window.location.href.split("?")[1] ? window.location.href.split("?")[1] : "";
        var decodedQuery = SearchSpring.decodeQuery(urlSearchParamsString);
        if (decodedQuery.search) {
            this.changed["search"] = true;
        }
        for (var _i = 0, _a = Object.keys(decodedQuery.filters); _i < _a.length; _i++) {
            var filter = _a[_i];
            this.changed["facet:" + filter] = true;
        }
        for (var _b = 0, _c = Object.keys(decodedQuery.ranges); _b < _c.length; _b++) {
            var range = _c[_b];
            this.changed["facet:" + range] = true;
        }
        /** NOTE: Always clear filters when parsing URLSearchParams - they MUST NOT be pre-defined within code */
        this.query.filters = {};
        this.setQuery(decodedQuery);
    };
    /** @hidden */
    SearchSpring.prototype.execSearch = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var query, response, request, pageHeightBefore_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = this.stringifySearchSpringSearchQuery();
                        if (!this.ready || !this.options.loadMore) {
                            this.loading = true;
                        }
                        if (((_a = this.current.pagination) === null || _a === void 0 ? void 0 : _a.currentPage) > this.query.results.page) {
                            this.loadingPrev = true;
                        }
                        else {
                            this.loadingNext = true;
                        }
                        this.update();
                        if (!this.memoize[query]) return [3 /*break*/, 1];
                        response = this.memoize[query];
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, fetch(this.apiEndpoints.search + "?" + query)];
                    case 2:
                        request = _b.sent();
                        return [4 /*yield*/, request.json()];
                    case 3:
                        response = _b.sent();
                        // Redirect browser when "merchandising.redirect" property is set 🤷‍♀️
                        if (response.merchandising && response.merchandising.redirect) {
                            window.location.href = response.merchandising.redirect;
                        }
                        response.sorting.options = response.sorting.options.map(function (option) {
                            return __assign(__assign({}, option), { value: option.field + ":" + option.direction });
                        });
                        response.facets = response.facets.map(function (facet) {
                            return __assign(__assign({}, facet), { type: facet.type || "list" });
                        });
                        /** NOTE: SearchSpring _sometimes_ returns a html string on the `response.results` property ... [[🤦‍♀️]] */
                        response.results = Array.isArray(response.results) ? response.results : [];
                        _b.label = 4;
                    case 4:
                        this.current.facets = response.facets;
                        this.current.pagination = response.pagination;
                        this.current.sorting = response.sorting;
                        this.current.merchandising = response.merchandising;
                        this.processAnalytics();
                        if (this.options.infinite || this.options.loadMore) {
                            this.infinite.results["" + this.current.pagination.currentPage] = response.results;
                            this.current.results = Object.keys(this.infinite.results).sort(function (a, b) { return parseInt(a, 10) < parseInt(b, 10) ? -1 : 1; }).reduce(function (results, page) { return __spreadArrays(results, _this.infinite.results[page]); }, []);
                        }
                        else {
                            this.current.results = response.results;
                        }
                        this.memoize[query] = response;
                        if (!this.ready) {
                            this.correctFacetValues();
                        }
                        if (this.ready && this.options.infinitePosition && this.loadingPrev) {
                            pageHeightBefore_1 = document.body.scrollHeight;
                            setTimeout(function () {
                                var pageHeightAfter = document.body.scrollHeight;
                                var pageHeightDifference = pageHeightAfter - pageHeightBefore_1;
                                window.scrollTo({
                                    top: pageHeightDifference + window.scrollY,
                                });
                            }, 0);
                        }
                        this.ready = true;
                        this.loading = false;
                        this.loadingNext = false;
                        this.loadingPrev = false;
                        this.update();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** @hidden */
    SearchSpring.prototype.execSuggest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = this.generateSearchSpringSuggestQuery();
                        if (!query.query) {
                            this.setSearch("");
                            return [2 /*return*/];
                        }
                        if (!this.memoize[query.query]) return [3 /*break*/, 1];
                        response = this.memoize[query.query];
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, fetch("" + this.apiEndpoints.suggest, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(query),
                        })];
                    case 2:
                        request = _a.sent();
                        return [4 /*yield*/, request.json()];
                    case 3:
                        response = _a.sent();
                        this.memoize[query.query] = response;
                        _a.label = 4;
                    case 4:
                        if (response.suggested) {
                            this.current.autocomplete = response.suggested.text;
                        }
                        else {
                            this.current.autocomplete = "";
                        }
                        if (response.alternatives) {
                            this.current.suggestions = response.alternatives.map(function (alternative) { return alternative.text; });
                        }
                        else {
                            this.current.suggestions = [];
                        }
                        this.update();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** @hidden */
    SearchSpring.prototype.execAutocomplete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.query.suggest = this.query.autocomplete;
                        query = this.generateSearchSpringSuggestQuery();
                        if (!this.memoize[query.query]) return [3 /*break*/, 1];
                        response = this.memoize[query.query];
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, fetch("" + this.apiEndpoints.suggest, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(query),
                        })];
                    case 2:
                        request = _a.sent();
                        return [4 /*yield*/, request.json()];
                    case 3:
                        response = _a.sent();
                        this.memoize[query.query] = response;
                        _a.label = 4;
                    case 4:
                        if (response.alternatives) {
                            this.current.suggestions = response.alternatives.map(function (alternative) { return alternative.text; });
                        }
                        else {
                            this.current.suggestions = [];
                        }
                        if (response.suggested) {
                            this.query.search = response.suggested.text;
                        }
                        else {
                            this.query.search = this.query.autocomplete;
                        }
                        return [4 /*yield*/, this.execSearch()];
                    case 5:
                        _a.sent();
                        this.update();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** @hidden */
    SearchSpring.prototype.processAnalytics = function () {
        try {
            // @ts-expect-error
            if (window.ga && this.current.merchandising.experiments) {
                for (var _i = 0, _a = this.current.merchandising.experiments; _i < _a.length; _i++) {
                    var experiment = _a[_i];
                    // @ts-expect-error
                    window.ga("send", "event", "Searchspring A/B Test", experiment.parentCampaignName, experiment.variationName, { nonInteraction: 1 });
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    /** Returns the currently selected facet value within the [[SearchSpring.query]] object. */
    SearchSpring.prototype.getFacetValue = function (facet) {
        if (this.query.filters[facet.field]) {
            return this.query.filters[facet.field];
        }
        if (this.query.ranges[facet.field]) {
            return this.query.ranges[facet.field];
        }
    };
    /** Sets a facet value within the [[SearchSpring.query]] object and updates results. */
    SearchSpring.prototype.setFacetValue = function (facet, value) {
        switch (value.type) {
            case SearchSpring.Query.Facet.Value.Type.VALUE:
                this.setFacetValueAsFilter(facet, value);
                break;
            case SearchSpring.Query.Facet.Value.Type.RANGE:
                this.setFacetValueAsRange(facet, value);
                break;
        }
        if (this.ready) {
            this.changed["facet:" + facet.field] = true;
        }
        this.clearPagination();
        this.setUrlSearchParams();
        this.update();
        this.execSearch();
    };
    /** Unsets a facet value within the [[SearchSpring.query]] object and updates results. */
    SearchSpring.prototype.unsetFacetValue = function (facet, value) {
        if (value && value.type === SearchSpring.Query.Facet.Value.Type.VALUE) {
            switch (facet.multiple) {
                case SearchSpring.Query.Facet.Multiple.UNION:
                case SearchSpring.Query.Facet.Multiple.INTERSECT:
                    this.query.filters[facet.field] = this.query.filters[facet.field].filter(function (existingValue) { return existingValue.value !== value.value; });
                    if (this.query.filters[facet.field].length === 0) {
                        this.unsetFacetValueByField(facet.field);
                    }
                    break;
                default:
                    this.unsetFacetValueByField(facet.field);
                    break;
            }
        }
        else {
            this.unsetFacetValueByField(facet.field);
        }
        this.clearPagination();
        this.setUrlSearchParams();
        this.update();
        this.execSearch();
    };
    /** Unsets (default: all) facet values within the [[SearchSpring.query]] object and updates results. */
    SearchSpring.prototype.unsetFacetValues = function (facets) {
        var fields = Array.isArray(facets) ? facets.map(function (facet) { return facet.field; }) : __spreadArrays(Object.keys(this.query.filters), Object.keys(this.query.ranges));
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            this.unsetFacetValueByField(field);
        }
        this.clearPagination();
        this.setUrlSearchParams();
        this.update();
        this.execSearch();
    };
    /** Sets the [[SearchSpring.Query.Sort]] property and updates results. */
    SearchSpring.prototype.setSort = function (field, direction) {
        this.query.sort.field = field;
        this.query.sort.direction = direction;
        if (this.ready) {
            this.changed.sortField = true;
            this.changed.sortDirection = true;
        }
        this.clearPagination();
        this.setUrlSearchParams();
        this.update();
        this.execSearch();
    };
    /** Sets the [[SearchSpring.Query.Suggest]] property and updates results. */
    SearchSpring.prototype.getSuggestions = function (term) {
        var _this = this;
        this.query.suggest = term;
        if (this.ready) {
            this.changed.suggest = true;
        }
        this.clearPagination();
        if (!this.debounce.suggest) {
            this.setUrlSearchParams();
            this.update();
            this.execSuggest();
        }
        else {
            this.debounce.suggest.exec(function () {
                _this.setUrlSearchParams();
                _this.update();
                _this.execSuggest();
            });
        }
        this.update();
    };
    /** Sets the [[SearchSpring.Query.Search]] property and updates results. */
    SearchSpring.prototype.setSearch = function (term) {
        var _this = this;
        this.query.search = term;
        if (this.ready) {
            this.changed.search = true;
        }
        this.clearPagination();
        if (!this.debounce.search) {
            this.setUrlSearchParams();
            this.update();
            this.execSearch();
        }
        else {
            this.debounce.search.exec(function () {
                _this.setUrlSearchParams();
                _this.update();
                _this.execSearch();
            });
        }
        this.update();
    };
    /** Sets the [[SearchSpring.Query.Autocomplete]] property and updates results. */
    SearchSpring.prototype.setAutocomplete = function (term) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.query.autocomplete = term;
                        this.update();
                        if (this.ready) {
                            this.changed.autocomplete = true;
                        }
                        this.clearPagination();
                        if (!!this.debounce.autocomplete) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.execAutocomplete()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.debounce.autocomplete.exec(function () { return _this.execAutocomplete(); })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.update();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Clears the [[SearchSpring.Query.Results]] property and results. */
    SearchSpring.prototype.clearPagination = function () {
        this.query.results.page = 1;
        this.infinite.results = {};
        this.infinite.pageStart = this.query.results.page;
        this.infinite.pageEnd = this.query.results.page;
        if (this.ready) {
            this.changed.resultsPage = true;
        }
        this.update();
    };
    /** Sets the [[SearchSpring.Query.Results]] property and updates results. */
    SearchSpring.prototype.setPagination = function (page, limit) {
        this.query.results.page = page;
        this.query.results.limit = limit;
        this.infinite.pageStart = this.infinite.pageStart || this.query.results.page;
        this.infinite.pageEnd = this.infinite.pageEnd || this.query.results.page;
        if (this.ready) {
            this.changed.resultsPage = true;
            this.changed.resultsLimit = true;
        }
        this.setUrlSearchParams();
        this.update();
        this.execSearch();
    };
    /** Sets the [[SearchSpring.Query.Results]] `page` property and updates results. */
    SearchSpring.prototype.setPaginationPage = function (value, exact) {
        if (exact === void 0) { exact = false; }
        if (exact) {
            this.query.results.page = value;
        }
        else {
            this.query.results.page = this.query.results.page + value < 1 ? 1 : this.query.results.page + value;
        }
        if (this.ready) {
            this.changed.resultsPage = true;
        }
        this.setUrlSearchParams();
        this.update();
        this.execSearch();
    };
    SearchSpring.prototype.infiniteLoadScroll = function () {
        if (this.loading) {
            return;
        }
        if (window.scrollY === 0) {
            this.infiniteLoadPrev();
        }
        if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
            this.infiniteLoadNext();
        }
        this.infiniteLoadTrackPage();
    };
    SearchSpring.prototype.infiniteLoadTrackPage = function () {
        if (this.loading) {
            return;
        }
        var shouldLoadPrev = window.scrollY === 0;
        var shouldLoadNext = (window.innerHeight + window.scrollY) >= document.body.scrollHeight;
        if (shouldLoadPrev) {
            this.infiniteLoadPrev();
        }
        if (shouldLoadNext) {
            this.infiniteLoadNext();
        }
        if (!shouldLoadNext && !shouldLoadPrev) {
            var pageIndex = this.infinite.regions.findIndex(function (position) { return window.scrollY + window.innerHeight > position; });
            var pageOffset = this.infinite.regions.length - pageIndex;
            var pageNumber = this.infinite.pageStart + pageOffset - 1;
            this.query.results.page = pageNumber;
            this.setUrlSearchParams();
            this.update();
        }
    };
    SearchSpring.prototype.infiniteLoadPrev = function () {
        var _this = this;
        var loadPrev = function () {
            if (_this.infinite.pageStart - 1 > 0) {
                _this.infinite.pageStart = _this.infinite.pageStart - 1;
                _this.infinite.regions.push(document.body.scrollHeight);
                _this.infinite.regions = _this.infinite.regions.sort(function (a, b) { return a > b ? -1 : 1; });
                _this.setPaginationPage(_this.infinite.pageStart, true);
            }
        };
        this.throttle.scroll ? this.throttle.scroll.exec(function () { return loadPrev(); }) : loadPrev();
    };
    SearchSpring.prototype.infiniteLoadNext = function () {
        var _this = this;
        var loadNext = function () {
            if (_this.infinite.pageEnd < _this.current.pagination.totalPages) {
                _this.infinite.pageEnd = _this.infinite.pageEnd + 1;
                _this.infinite.regions.push(window.scrollY + window.innerHeight);
                _this.infinite.regions = _this.infinite.regions.sort(function (a, b) { return a > b ? -1 : 1; });
                _this.setPaginationPage(_this.infinite.pageEnd, true);
            }
        };
        this.throttle.scroll ? this.throttle.scroll.exec(function () { return loadNext(); }) : loadNext();
    };
    SearchSpring.prototype.loadMorePrev = function () {
        this.infinite.pageStart = this.infinite.pageStart - 1;
        this.setPaginationPage(this.infinite.pageStart, true);
    };
    SearchSpring.prototype.loadMoreNext = function () {
        this.infinite.pageEnd = this.infinite.pageEnd + 1;
        this.setPaginationPage(this.infinite.pageEnd, true);
    };
    /** Converts the [[SearchSpring.query]] object into a querystring for the SearchSpring Search API */
    SearchSpring.prototype.stringifySearchSpringSearchQuery = function () {
        var queryArray = [];
        if (this.options.siteId) {
            queryArray.push("siteId=" + this.options.siteId);
        }
        if (this.options.userId) {
            queryArray.push("userId=" + this.options.userId);
        }
        if (this.query.results.format) {
            queryArray.push("resultsFormat=" + this.query.results.format);
        }
        if (this.query.results.hasOwnProperty("page")) {
            queryArray.push("page=" + this.query.results.page);
        }
        if (this.query.results.hasOwnProperty("limit")) {
            queryArray.push("resultsPerPage=" + this.query.results.limit);
        }
        if (this.query.search) {
            queryArray.push("q=" + encodeURIComponent(this.query.search));
        }
        if (this.query.sort.field) {
            queryArray.push("sort." + this.query.sort.field + "=" + encodeURIComponent(this.query.sort.direction));
        }
        if (this.query.tag) {
            queryArray.push("tag=" + encodeURIComponent(this.query.tag));
        }
        var _loop_1 = function (field) {
            if (Array.isArray(this_1.query.filters[field])) {
                queryArray.push.apply(queryArray, this_1.query.filters[field].map(function (value) { return "filter." + field + "=" + encodeURIComponent(value.value); }));
            }
            else {
                queryArray.push("filter." + field + "=" + encodeURIComponent(this_1.query.filters[field].value));
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(this.query.filters); _i < _a.length; _i++) {
            var field = _a[_i];
            _loop_1(field);
        }
        for (var _b = 0, _c = Object.keys(this.query.ranges); _b < _c.length; _b++) {
            var range = _c[_b];
            queryArray.push("filter." + range + ".low=" + encodeURIComponent(this.query.ranges[range].low), "filter." + range + ".high=" + encodeURIComponent(this.query.ranges[range].high));
        }
        for (var _d = 0, _e = Object.keys(this.query.bgFilters); _d < _e.length; _d++) {
            var field = _e[_d];
            queryArray.push("bgfilter." + field + "=" + encodeURIComponent(this.query.bgFilters[field]));
        }
        if (this.options.addCurrentUrl) {
            queryArray.push("domain=" + window.location.href);
        }
        return queryArray.join("&");
    };
    /** Converts the [[SearchSpring.query]] object into a querystring for the SearchSpring Suggest API */
    SearchSpring.prototype.generateSearchSpringSuggestQuery = function () {
        var query = {
            siteId: this.options.siteId,
            userId: this.options.userId,
            query: this.query.suggest,
        };
        return query;
    };
    SearchSpring.prototype.setUrlSearchParams = function () {
        if (this.options.querystring) {
            var currUrlSearchParams = SearchSpring.encodeQuery(SearchSpring.decodeQuery(window.location.href.split("?")[1]), this.changed);
            var nextUrlSearchParams = SearchSpring.encodeQuery(this.query, this.changed);
            if (currUrlSearchParams !== nextUrlSearchParams) {
                window.history.pushState({}, "", SearchSpring.queryToUrl(this.query, this.changed, "") || "?");
            }
        }
    };
    /** @hidden */
    SearchSpring.prototype.setProvider = function (provider) {
        this.provider = provider;
    };
    /** Sets a background filter value within the [[SearchSpring.query]] object and updates results. */
    SearchSpring.prototype.setBackgroundFilterValue = function (bgFilter, value) {
        var _this = this;
        if (value) {
            this.query.bgFilters[bgFilter.field] = value;
        }
        else {
            this.query.bgFilters = Object.keys(this.query.bgFilters).reduce(function (bgFilters, bgFilterKey) {
                var _a;
                return bgFilterKey === bgFilter.field ? bgFilters : __assign(__assign({}, bgFilters), (_a = {}, _a[bgFilterKey] = _this.query.bgFilters[bgFilterKey], _a));
            }, {});
        }
        this.setUrlSearchParams();
        this.update();
        this.execSearch();
    };
    /** Sets correct Facet values within [[Searchspring.query]] based on existing properties ([URLSearchParams](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams) or [[Options.query]]) */
    SearchSpring.prototype.correctFacetValues = function () {
        var _this = this;
        var queryObject = {
            filters: {},
            ranges: {},
        };
        var _loop_2 = function (filterKey) {
            var filterFacet = this_2.current.facets.find(function (facet) { return facet.field === filterKey; });
            if (filterFacet) {
                var filterValue = void 0;
                switch (filterFacet.multiple) {
                    case SearchSpring.Query.Facet.Multiple.UNION:
                    case SearchSpring.Query.Facet.Multiple.INTERSECT:
                        // Ensure filter value is `Array<value>` type, this cannot be determined prior due to insufficent information
                        this_2.query.filters[filterKey] = Array.isArray(this_2.query.filters[filterKey]) ? this_2.query.filters[filterKey] : [this_2.query.filters[filterKey]];
                        filterValue = filterFacet.values.filter(function (value) { return value.type === SearchSpring.Query.Facet.Value.Type.VALUE && _this.query.filters[filterKey].map(function (nestedValue) { return nestedValue.value; }).includes(value.value.toString()); });
                        break;
                    default:
                        filterValue = filterFacet.values.find(function (value) { return value.type === SearchSpring.Query.Facet.Value.Type.VALUE && value.value.toString() === _this.query.filters[filterKey].toString(); });
                        break;
                }
                if (filterValue) {
                    queryObject.filters[filterKey] = filterValue;
                }
            }
        };
        var this_2 = this;
        for (var _i = 0, _a = Object.keys(this.query.filters); _i < _a.length; _i++) {
            var filterKey = _a[_i];
            _loop_2(filterKey);
        }
        var _loop_3 = function (rangeKey) {
            var rangeFacet = this_3.current.facets.find(function (facet) { return facet.field === rangeKey; });
            if (rangeFacet) {
                var rangeValue = rangeFacet.values.find(function (value) { return value.type === SearchSpring.Query.Facet.Value.Type.RANGE && value.low + "," + value.low === _this.query.ranges[rangeKey].low + "," + _this.query.ranges[rangeKey].low; });
                if (rangeValue) {
                    queryObject.ranges[rangeKey] = rangeValue;
                }
            }
        };
        var this_3 = this;
        for (var _b = 0, _c = Object.keys(this.query.ranges); _b < _c.length; _b++) {
            var rangeKey = _c[_b];
            _loop_3(rangeKey);
        }
        this.setQuery(queryObject);
        this.setUrlSearchParams();
    };
    /** @hidden */
    SearchSpring.prototype.unsetFacetValueByField = function (field) {
        var _this = this;
        this.query.filters = Object.keys(this.query.filters).reduce(function (filters, filterKey) {
            var _a;
            return filterKey === field ? filters : __assign(__assign({}, filters), (_a = {}, _a[filterKey] = _this.query.filters[filterKey], _a));
        }, {});
        this.query.ranges = Object.keys(this.query.ranges).reduce(function (ranges, rangeKey) {
            var _a;
            return rangeKey === field ? ranges : __assign(__assign({}, ranges), (_a = {}, _a[rangeKey] = _this.query.ranges[rangeKey], _a));
        }, {});
    };
    /** @hidden */
    SearchSpring.prototype.setQuery = function (query) {
        this.query = __assign(__assign({}, this.query), { filters: __assign(__assign({}, this.query && this.query.filters), query.filters), ranges: __assign(__assign({}, this.query && this.query.ranges), query.ranges), bgFilters: __assign(__assign({}, this.query && this.query.bgFilters), query.bgFilters), sort: {
                field: query.sort && query.sort.field !== undefined ? query.sort.field : this.query && this.query.sort.field,
                direction: query.sort && query.sort.direction !== undefined ? query.sort.direction : this.query && this.query.sort.direction,
            }, results: {
                format: query.results && query.results.format !== undefined ? query.results.format : this.query && this.query.results.format,
                limit: query.results && query.results.limit !== undefined ? query.results.limit : this.query && this.query.results.limit,
                page: query.results && query.results.page !== undefined ? query.results.page : this.query && this.query.results.page,
            }, search: query.search || this.query && this.query.search, tag: query.tag || this.query && this.query.tag });
    };
    /** Sets a filter property within [[SearchSpring.query.filters]] and updates results. */
    SearchSpring.prototype.setFacetValueAsFilter = function (facet, value) {
        switch (facet.multiple) {
            case SearchSpring.Query.Facet.Multiple.UNION:
            case SearchSpring.Query.Facet.Multiple.INTERSECT:
                if (this.query.filters[facet.field] && Array.isArray(this.query.filters[facet.field])) {
                    this.query.filters[facet.field] = __spreadArrays(this.query.filters[facet.field], [value]);
                }
                else {
                    this.query.filters[facet.field] = [value];
                }
                break;
            default:
                this.query.filters[facet.field] = value;
                break;
        }
    };
    /** Sets a range property within [[SearchSpring.query.ranges]] and updates results. */
    SearchSpring.prototype.setFacetValueAsRange = function (facet, value) {
        this.query.ranges[facet.field] = value;
    };
    /** @hidden */
    SearchSpring.prototype.update = function () {
        if (this.provider) {
            this.provider.setState({ searchspring: this });
        }
    };
    SearchSpring.Component = {
        Cloud: components_1.SSCloud,
        Consumer: components_1.SSConsumer,
        Debugger: components_1.SSDebugger,
        Filter: components_1.SSFilter,
        Pagination: components_1.SSPagination,
        Merchandising: {
            Banner: components_1.SSMerchandisingBanner,
        },
        Provider: components_1.SSProvider,
        Results: components_1.SSResults,
        Search: components_1.SSSearch,
        Sort: components_1.SSSort,
        Suggest: components_1.SSSuggest,
    };
    return SearchSpring;
}());
exports.SearchSpring = SearchSpring;
(function (SearchSpring) {
    var Query;
    (function (Query) {
        var Results;
        (function (Results) {
            var Format;
            (function (Format) {
                Format["NATIVE"] = "native";
            })(Format = Results.Format || (Results.Format = {}));
        })(Results = Query.Results || (Query.Results = {}));
        var Sort;
        (function (Sort) {
            var Direction;
            (function (Direction) {
                Direction["ASC"] = "asc";
                Direction["DESC"] = "desc";
            })(Direction = Sort.Direction || (Sort.Direction = {}));
        })(Sort = Query.Sort || (Query.Sort = {}));
        var Facet;
        (function (Facet) {
            var Value;
            (function (Value) {
                var Type;
                (function (Type) {
                    Type["VALUE"] = "value";
                    Type["RANGE"] = "range";
                })(Type = Value.Type || (Value.Type = {}));
            })(Value = Facet.Value || (Facet.Value = {}));
            var Type;
            (function (Type) {
                Type["HIERARCHY"] = "hierarchy";
                Type["LIST"] = "list";
                Type["GRID"] = "grid";
                Type["PALETTE"] = "palette";
                Type["SLIDER"] = "slider";
            })(Type = Facet.Type || (Facet.Type = {}));
            var Multiple;
            (function (Multiple) {
                Multiple["SINGLE"] = "single";
                Multiple["UNION"] = "multiple-union";
                Multiple["INTERSECT"] = "multiple-intersect";
            })(Multiple = Facet.Multiple || (Facet.Multiple = {}));
        })(Facet = Query.Facet || (Query.Facet = {}));
    })(Query = SearchSpring.Query || (SearchSpring.Query = {}));
})(SearchSpring = exports.SearchSpring || (exports.SearchSpring = {}));
exports.SearchSpring = SearchSpring;
//# sourceMappingURL=searchspring.js.map